import { Dayjs } from 'dayjs';

export const GTM_TAG_VALUE = '1';

export type GoogleTagManagerTag = 'Onboarding' | 'MIDApproved' | undefined;

export function getGoogleTagManagerTag(
    hasMid: boolean,
    lastDonationDate: Dayjs | null,
): GoogleTagManagerTag {
    return hasMid
        ? lastDonationDate
            ? undefined
            : 'MIDApproved'
        : 'Onboarding';
}
